<template>
  <div class="home">
    <header class="app-header">
      <div class="sidebar-logo">
        <img src="@/assets/logo.png" alt="瑞秋国际物流" />
      </div>
      <top-menu @change-password="passwordDialogVisible = true" />
    </header>

    <div class="app-body">
      <aside class="sidebar">
        <ment />
      </aside>

      <section class="main">
        <main class="menu_content">
          <el-scrollbar>
            <router-view>
              <template #default="{ Component, route }">
                <transition name="fade-slide" mode="out-in">
                  <keep-alive>
                    <component :is="Component" :key="route.fullPath" />
                  </keep-alive>
                </transition>
              </template>
            </router-view>
          </el-scrollbar>
        </main>
      </section>
    </div>

    <first-login-password-dialog v-model:visible="passwordDialogVisible" />
  </div>
</template>

<script setup>
import topMenu from "./topMenu.vue";
import ment from "./ment.vue";
import { getCurrentInstance, ref } from "vue";

defineOptions({
  name: "HomeLayout",
});

const passwordDialogVisible = ref(false);
const { proxy } = getCurrentInstance();
const { $loading } = proxy;
$loading().close();
</script>

<style scoped lang="scss">
.home {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: var(--app-bg-color);
}

.app-header {
  display: flex;
  flex: 0 0 60px;
  align-items: stretch;
  width: 100%;
  height: 60px;
  background: linear-gradient(90deg, #e5d5c0 0%, #bcc6cc 61.16%, #8eadbf 100%);
  border-bottom: 1px solid var(--app-border-color);
}

.sidebar-logo {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  height: 60px;
  padding: 0 18px;
  // border-bottom: 1px solid #f2f3f5;

  img {
    display: block;
    // width: 160px;
    // max-height: 45px;
    height: 30px;
  }
}

:global(html[data-app-theme="dark"]) .app-header {
  background: linear-gradient(90deg, #3a3025 0%, #2f383f 61.16%, #244153 100%);
}

.app-body {
  display: flex;
  flex: 1;
  min-height: 0;
}

.sidebar {
  position: relative;
  z-index: 2;
  display: flex;
  flex: 0 0 180px;
  flex-direction: column;
  width: 180px;
  min-height: 0;
  overflow: hidden;
  background: var(--app-surface-color);
  border-right: 1px solid var(--app-border-color);
}

.main {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

:global(.app-body:has(.home-list-drawer) .main) {
  position: relative;
  z-index: 3;
}

.menu_content {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  background: var(--app-bg-color);
  padding: 10px;

  .el-scrollbar {
    height: 100%;
  }
}

:deep(.el-scrollbar__view) {
  height: 100%;
  min-height: 100%;
}

@media (max-width: 960px) {
  .sidebar {
    flex-basis: 176px;
    width: 176px;
  }

  .sidebar-logo {
    padding: 0 16px;

    img {
      width: 144px;
    }
  }
}
</style>
